<template>
  <div>

      <div :style="{
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'flex-start',
          alignItems: 'flex-start',
          textAlign: 'left'
        }">
            <div style="margin-top: 10px;">
                <span type="label">Customer's Next Visit/Pickup Date?</span>
                <br>
                <el-date-picker
                    size="small"
                    type="date"
                    v-model="workOrderData.appointment_date"
                    style="width: 400px;" 
                    value-format="yyyy-MM-dd"
                    format="MMM dd yyyy">
                </el-date-picker>
            </div>
            <el-checkbox style="margin-top: 10px; color: red;" v-model="workOrderData.priority_order">Priority Order?</el-checkbox>
            <div v-if="$store.getters.getPreferenceProps.customer_measurement_required" style="margin-top: 20px;">
                <span type="label">Visit Is For?</span>
                <br>
                <el-radio @change="toggleProcessList" :label="0" v-model="workOrderData.appointment_type">Delivery</el-radio>
                <el-radio :label="1" @change="toggleProcessList" v-model="workOrderData.appointment_type">Trial</el-radio>
            </div>
            
            <div style="margin-top: 20px;" v-if="$store.getters.getTailoringTrialTypeList.length>0 && workOrderData.appointment_type === 1">
                <span type="label">Trial Type</span>
                <br>
                <el-select v-model="workOrderData.trial_type_id" size="small" style="width: 400px;">
                    <el-option
                        v-for="(data, index) in $store.getters.getTailoringTrialTypeList"
                        :key="index"
                        :label="data.trial_type"
                        :value="data.id">
                            <span style="float: left;">
                                {{data.trial_type}}
                            </span>                               
                    </el-option>  
                </el-select>
            </div>
            <div style="margin-top: 20px;" v-if="!$store.getters.getPreferenceProps.customer_measurement_required">
                <span type="label">To Be Tailored By?</span>
                <br>
                <el-select 
                    size="small"
                    v-model="workOrderData.customer_measurement_profile.measured_by_staff_id" 
                    filterable style="width: 400px; text-align: left;">
                    <el-option
                        v-for="(data, index) in $store.getters.getEmployeeMasterList.filter(t => t.active && t.can_take_measurement)"
                        :key="index"
                        :label="data.staff_name"
                        :value="data.id">
                        <span style="float: left" v-html="data.staff_name"></span>
                    </el-option>
                </el-select>
            </div>

            <div style="margin-top: 20px;">
                <span type="label">Special Instructions?</span>
                <br>
                <el-input @focus="$event.target.select()"
                    type="textarea"
                    rows="2"
                    v-model="workOrderData.special_instruction"
                    style="width: 400px;">
                </el-input>
            </div>
            <div style="margin-top: 10px;">
                <span type="label">Additional Item Details (If Any)</span>
                <br>
                <el-input @focus="$event.target.select()"
                    size="small"
                    v-model="workOrderData.item_details"
                    style="width: 400px;">
                </el-input>
            </div>
            <div style="margin-top: 10px;">
                <span type="label">Placement Rack No.</span>
                <br>
                <el-input @focus="$event.target.select()"
                    size="small"
                    v-model="workOrderData.placement_rack_number"
                    style="width: 400px;">
                </el-input>
            </div>
            <div style="margin-top: 10px;">
                <span type="label">Remarks</span>
                <br>
                <el-input @focus="$event.target.select()"
                    size="small"
                    v-model="workOrderData.internal_remarks"
                    style="width: 400px;">
                </el-input>
            </div>

        </div>

  </div>
</template>

<script>
export default {
    props: ['workOrderData', 'wo_confirmed'],
    computed: {
        getAppointmentType() {
            return this.workOrderData.appointment_type
        }
    },
    methods: {
        toggleProcessList() {
            let appointment_type = this.getAppointmentType
            this.workOrderData.process_list.forEach(element => {
                if(element.hidden_process === 1 && appointment_type === 1) {
                    element.is_required = true
                } else if(element.hidden_process === 2 && appointment_type === 1) {
                    element.is_required = false
                } 
                 
                if(element.hidden_process === 1 && appointment_type === 0) {
                    element.is_required = false
                } else if(element.hidden_process === 2 && appointment_type === 0) {
                    element.is_required = true
                }
            })
        }
    },
    mounted() {
        
        setTimeout(() => {
            this.toggleProcessList()
        }, 1000);
        
        if(!this.wo_confirmed) {
            
            let sale_item_id = this.workOrderData.sale_item_id    
            
            if(this.$store.getters.getSaleMasterDataProps.trial_required) {
                this.workOrderData.appointment_type = 1   

            }

            let itemTrial = this.$store.getters.getSaleMasterDataProps.item_list.filter(t => t.id === sale_item_id)[0].tailoring_trial_required
            if(itemTrial) {
                this.workOrderData.appointment_type = itemTrial ? 1 : 0
            }
            
            this.workOrderData.special_instruction = this.$store.getters.getSaleMasterDataProps.item_list.filter(t => t.id === sale_item_id)[0].notes

            if(this.workOrderData.appointment_type === 0) {
                //this.workOrderData.appointment_date = this.$store.getters.getSaleMasterDataProps.delivery_date            
            } else {
                //this.workOrderData.appointment_date = this.$store.getters.getSaleMasterDataProps.trial_date            
            }
        }
        
    }
}
</script>

<style>

</style>


// WEBPACK FOOTER //
// src/views/WorkOrder/PromiseDetail.vue